import React from "react";
import {
  Box,
} from "@mui/material";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import TrustedBy from "../components/TrustedBy";
import WhyChooseUs from "../components/WhyChooseUs";
import OrderFlow from "../components/OrderFlow";
import CallToAction from "../components/CallToAction";
import PageTitle from "../components/PageTitle";

export default function Home() {
  return (
    <Box
      sx={{
        bgcolor: "#ffffff",
        overflowX: "hidden",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <PageTitle
        title="RestaurantWala – Smart Restaurant Management System"
        description="RestaurantWala is an all-in-one restaurant management system for menus, orders, billing, staff, tables, QR menus, offers and reports."
        keywords="restaurant management system, restaurant software, restaurant billing software, restaurant POS, QR menu, restaurant order management, restaurant software India"
      />
      <Navbar />
      <Hero />
      <TrustedBy />
      <WhyChooseUs />
      <HowItWorks />
     {/* <OrderFlow /> */}
     <CallToAction /> 
     {/* <Testimonials /> */}
      <Footer />
    </Box>
  );
}